import { PostNote } from '@/type';
import recognition from '@/auth/recognition';
import eventBus from '@/messaging/event-bus';
import { PostNoteAdded } from '@/messaging/events';
import api from '../../API';

// eslint-disable-next-line import/prefer-default-export
export function add(postId: number, content: string, userId?: number): Promise<PostNote> {
  const url = `posts/${postId}/notes`;
  return api
    .post(url, {
      content,
      userId: userId || recognition.getUserId(),
    }).then((response) => {
      const postNote: PostNote = (response.data as PostNote);
      eventBus.$emit(PostNoteAdded.eventName, new PostNoteAdded(postNote));
      return postNote;
    });
}
